__turbopack_context__.v({
  "active": "MobileMenu-module__-S_3-a__active",
  "menuToggle": "MobileMenu-module__-S_3-a__menuToggle",
  "open": "MobileMenu-module__-S_3-a__open",
  "overlay": "MobileMenu-module__-S_3-a__overlay",
  "sidebar": "MobileMenu-module__-S_3-a__sidebar",
});
